import React from "react";
import { useTranslation } from "react-i18next";
import { formatSalary, MASKED_AMOUNT } from "utils/format-salary";
import SensitiveText from "./SensitiveText";

interface SensitiveAmountProps {
  value: number | string | null | undefined;
  className?: string;
}

/** A salary figure shown as «•••• €» until the viewer clicks the eye (see SensitiveText). */
export default function SensitiveAmount({ value, className }: SensitiveAmountProps) {
  const { t } = useTranslation();
  return (
    <SensitiveText
      text={formatSalary(value)}
      mask={MASKED_AMOUNT}
      showLabel={t("show_amount")}
      hideLabel={t("hide_amount")}
      className={className}
    />
  );
}
